<template>
<Layout class="live-page" :class="{'is-live': webcast.status == 'live', 'hasStreams': hasStreams, 'hasCTA': pageSettings.callToActionEnabled}">
  <Layout class="main-layout" v-if="isReady">
    <Content class="live-content" style="overflow:visible;">
      <LivePlayer v-if="!webcast.enableP2P"></LivePlayer>
      <LivePlayerP2P v-if="webcast.enableP2P"></LivePlayerP2P>
    </Content>
    
    <Sider class="live-sider" v-if="widgets.length>=1" :class="{'hasStreams': hasStreams}" ref="sider" width="480" collapsed-width="0" hide-trigger collapsible v-model="isCollapsed">
      <Layout>
        <Button @click="closeWidget" shape="circle" class="sider-toggle-btn" :class="{'collapsed': isCollapsed}" :icon="siderIcon"></Button>
        <widget-container :isCollapsed="isCollapsed"></widget-container>
      </Layout>
    </Sider>
  </Layout>
</Layout>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'
import LivePlayer from '@/components/LivePlayer.vue'
import LivePlayerP2P from '@/components/LivePlayerP2P.vue'
import WidgetContainer from '@/components/widgets/WidgetContainer.vue'


export default {
  name: 'live',
  data() {
    return {
      attId: "",
      isCollapsed: false,
      isReady: false,
      sidebarContent: null
    };
  },
  computed:{
    ...mapGetters('stream', {
      streamsInStore: 'find',
      getStreamInStore: 'get'
    }),
    ...mapGetters('registrations', {
			registration: 'getCopy',
    }),
    ...mapGetters('page-settings', {
			pageSettings: 'getCopy',
		}),
    ...mapGetters('webcast', {
      webcast: 'getCopy',
    }),
    ...mapGetters('widgets', {
      findWidgetsInStore: 'find'
    }),
    widgets () {
      return this.findWidgetsInStore().data
    },
    siderIcon(){

      if(this.isCollapsed){
        return 'ios-arrow-back'  
      } else {
        return 'ios-arrow-forward'
      }
    },
    hasStreams(){
      if(this.webcast.status != 'live') return false;
      else if(this.streamsInStore().data.length>1) return true;
      else return false;
    }
  },
  watch:{
  
  },
  methods: {
    ...mapActions('registrations', {
      initUserAction: 'initUser'
    }),
    ...mapActions('widgets', {
      findWidgetsAction: 'find'
    }),

    collapsedSider() {
      this.$refs.sider.toggleCollapse();
    },

    openWidget (index) {
      let widget = this.widgets[index]

      if (_.isEqual(this.currentWidget, widget) || this.isCollapsed) {
        this.collapsedSider()
      }
      this.currentWidget = widget
      //console.log(this.currentWidget);
    },

    closeWidget () {
      this.collapsedSider()
      //this.currentWidget = undefined
    }
  },
  created(){
    this.$store.commit('widgets/clearAll');
    this.findWidgetsAction({query: {webcastId: this.webcast._id}}).then(res => {
      this.$set(this.$data, 'isReady', true);
      
      //console.log(this.$data.currentWidget);
    })
  },

  components: {
    LivePlayer,
    LivePlayerP2P,
    WidgetContainer
  }
}
</script>

<style lang="less">
.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size .2s ease .2s, transform .2s ease .2s;
  vertical-align: middle;
  font-size: 22px;
}

.sider-toggle-btn{
  position: absolute;
  right: 485px;
  width: 36px !important;
  height: 36px !important;
  top: 12px;
  &.collapsed{
    right:10px;
  }
}


.live-page {
  height: 100vh;
  .live-content {
    background-color: #000;
    @media screen and (max-width: 992px) {
      width: 100%;
      z-index: 10;
      position: absolute;
    }
  }
}

.live-sider{
  border-left: 1px solid #e9eaec;
}


@media screen and (max-width: 992px) {
  .live-page {
    .live-content {
      width: 100%;
      z-index: 1000;
    }
    .live-sider{
      border-left: none;
    }

    

    .main-layout {
      //flex-wrap: wrap;
    }
    
    .ivu-layout-sider {
      width: 100% !important;
      max-width: inherit !important;
      flex-basis: 100% !important;
      flex: inherit !important;
      padding-top: 56.25%;
      position: absolute;
      height: 100vh;
    }

    .ivu-layout-content {
      //height: 45vh;
      
      overflow: visible;
      overflow-x: hidden;
    }

    .ivu-layout-sider {
      //height: ~"calc(100vh - (45vh + 30px))";
      min-width: inherit !important;
    }

    .ivu-layout {
      padding-bottom: 0 !important;
      height: 100%;
    }
  }
  .hasStreams .ivu-layout-sider{
    padding-top: calc(56.25% + 48px);
  }

  .hasCTA .ivu-layout-sider{
    padding-top: calc(56.25% + 48px);
  }
}

</style>
